import React, { useState, useEffect } from "react";

import {
  Typography,
  Modal,
  CircularProgress,
  Box,
  Snackbar,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  LinearProgress,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { WarningRounded } from "@mui/icons-material";

import "./styles.scss";
import { DeleteRounded } from "@mui/icons-material";

import { Button } from "@fragments";
import { Text } from "@fragments";

function ModalAlert({ errorTitle, errorMessage }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (errorTitle || errorMessage) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [errorTitle, errorMessage]);

  if (!visible || (!errorTitle && !errorMessage)) return null;

  return (
    <div className="modal-alert error">
      <div className="alert-header">
        <Text.span
          weight={400}
          grow
          left={<WarningRounded />}
        >
          {errorTitle || "Houve um erro"}
        </Text.span>
      </div>

      {errorMessage && (
        <>
          <div className="alert-footer">
            <Text.span>
              {errorMessage}
            </Text.span>
          </div>
        </>
      )}
    </div>
  );
}

export default function CustomModal({
  maxWidth = 1027,
  bottomButtonSumbitText,
  bottomButtonSumbitIcon,
  bottomButtonCancelText = "Cancelar",
  handleSecondary,
  hideSecondaryButton = false,
  loading,
  disabled = false,
  snackbar = {},
  title,
  topActions = null,
  customTitle,
  handleSubmit,
  open = false,
  handleClose,
  width = "100%",
  bodyWrapperStyle = {},
  bodyComponent,
  mainButtonColor = "primary",
  bottomButtonsOrientation = "horizontal",
  className = "",
  handleDelete,
  deletionTitle,
  errorTitle,
  errorMessage,
}) {
  const [deletionOpen, setDeletionOpen] = React.useState(false);

  function deletionHandler() {
    window.openConfirm({
      subtitle: deletionTitle,
      buttons: [
        {
          text: "Apagar permanentemente",
          onClick: handleDelete,
          variant: "contained",
          className: "",
          color: "error",
        },
        {
          text: "Manter recurso",
          variant: "text",
        },
      ],
    });
  }

  const Header = () => (
    <div className={"custom-modal-header"}>
      {customTitle ? (
        customTitle
      ) : (
        <Typography
          style={{ flexGrow: 1 }}
          component="h3"
          className="bold my-1"
        >
          {title}
        </Typography>
      )}
      {topActions}
      {handleDelete && (
        <Button
          onClick={deletionHandler}
          color="error"
          startIcon={<DeleteRounded color="error" fontSize="small" />}
          className="mr-2"
        >
          Apagar
        </Button>
      )}
      {handleClose && (
        <IconButton
          onClick={handleClose}
          children={<CloseIcon />}
          className="modal-close-button"
        />
      )}

      {loading && <LinearProgress indeterminate className="loader-modal" />}
    </div>
  );

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{ maxWidth: maxWidth, width: width }}
          className={"custom-modal " + className}
        >
          <Header />

          <div className="custom-modal-body">
            <div className="custom-modal-content pb-5" style={bodyWrapperStyle}>
              {bodyComponent}
            </div>
          </div>

          <Snackbar
            className="modal-snackbar"
            open={!!snackbar?.value}
            autoHideDuration={6000}
            onClose={snackbar?.onClose}
            message={snackbar?.value}
          />

          <ModalAlert errorTitle={errorTitle} errorMessage={errorMessage} />

          {(!hideSecondaryButton || !!bottomButtonSumbitText) && (
            <div
              className="buttons-bottom"
              style={{
                flexDirection:
                  bottomButtonsOrientation === "vertical" ? "column" : "row",
                gap: 8,
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              {!hideSecondaryButton && (
                <Button
                  size="large"
                  color="overlay"
                  onClick={handleSecondary || handleClose}
                  disabled={loading}
                >
                  {bottomButtonCancelText}
                </Button>
              )}
              {!!bottomButtonSumbitText && (
                <Button
                  onClick={handleSubmit}
                  disabled={loading || disabled}
                  size="large"
                  color={mainButtonColor}
                  children={
                    bottomButtonSumbitText
                  }
                  startIcon={!loading && bottomButtonSumbitIcon}
                  variant="contained"
                />
              )}
            </div>
          )}
        </Box>
      </Modal>
      <DeletionDialog
        open={deletionOpen}
        setOpen={setDeletionOpen}
        title={deletionTitle}
        handler={handleDelete}
      />
    </div>
  );
}

function DeletionDialog({ title, handler, open, setOpen }) {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    setLoading(true);

    await handler();

    setLoading(false);
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} className="deletion-modal-area">
        <DialogContent>
          <h2>Atenção</h2>

          <span>{title}</span>
        </DialogContent>
        <DialogActions className="px-3 pb-2">
          <Button
            style={{
              color: "black",
            }}
            onClick={handleClose}
          >
            Cancelar
          </Button>
          <Button
            className="confirm-deletion py-1 px-2"
            color="error"
            variant="contained"
            loading={loading}
            disabled={loading}
            onClick={handleSubmit}
            autoFocus
          >
            Apagar permanentemente
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
